import { render, staticRenderFns } from "./ReportingMetrics.vue?vue&type=template&id=652e9164&"
import script from "./ReportingMetrics.vue?vue&type=script&lang=js&"
export * from "./ReportingMetrics.vue?vue&type=script&lang=js&"
import style0 from "./ReportingMetrics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports